import NinetyDaysCard from "./NinetyDaysCard";
import Spinner from "../spinner/Spinner";
import LeaderBoardStyles from "./LeaderBoardStyles.module.css";
import {LeaderBoardNinetyDaysProps} from "../../types/ComponentProps";

const LeaderboardNinetyDaysList = ({
  leaderboardData,
  loadingLeaderboard,
}: LeaderBoardNinetyDaysProps) => {
  const leaderboard = leaderboardData?.showNinetyDaysLeaderboard ?? [];
  return (
    <div className={LeaderBoardStyles?.leaderboardListContainer}>
      {loadingLeaderboard ? (
        <Spinner alignSpin="center-spinner" variant="small-spinner" />
      ) : (
        leaderboard
          .slice(0, 5)
          .map((data) => <NinetyDaysCard key={data.user.id} data={data} />)
      )}
    </div>
  );
};

export default LeaderboardNinetyDaysList;
